import routeTranslations from '../../assets/json/route-translations';

export const Locale = {};

for (const locale in routeTranslations) {
  Locale[locale.toLowerCase()] = locale;
}

Object.freeze(Locale);
